<template>
  <v-simple-table fixed-header height="240px">
    <template v-slot>
      <thead>
        <tr>
          <th class="text-left">
            {{ label }}
          </th>
          <th>
            Num
          </th>
          <th>
            %
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data || []" :key="item.label">
          <td>{{ item.label }}</td>
          <td>{{ item.count }}</td>
          <td>{{ item.percentage }}%</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ChartTable',
  props: {
    label: {
      type: String,
      default: 'Cliente',
    },
    data: {
      type: [Array, Object, null],
      default() {
        return []
      },
    },
  },
}
</script>
